export function SortAscending({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="sort-ascending">
        <path
          id="Vector"
          // eslint-disable-next-line max-len
          d="M3.33301 5H9.16634M3.33301 10H9.16634M3.33301 15H10.833M12.4997 7.5L14.9997 5M14.9997 5L17.4997 7.5M14.9997 5V15"
          stroke="currentColor"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}
